// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@keller/XDL/types";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        css: css`
            input {
                & + label {
                    line-height: 24px;
                }

                & + label:before {
                    height: 14px;
                    width: 14px;
                }

                &:focus + label::before {
                    box-shadow: none;
                }

                &:checked:not(:disabled) + label::before {
                    border-color: ${color("common.ui6")};
                    background: transparent;
                }
                &:checked + label::after {
                    height: 12px;
                    width: 12px;
                    background: ${color("primary")};
                    transform: scale(0.8);
                    left: 1px;
                    top: initial;
                }
                &:focus:not(:disabled) + label::before {
                    border-color: ${color("common.ui2")};
                }

                &:hover:not(:disabled) + label {
                    cursor: pointer;
                    &::before {
                        border-color: ${color("common.ui1")};
                    }
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["radio"];
